import { makeStyles } from "@material-ui/core";
import {
  Box,
  Button,
  Divider,
  InputAdornment,
  TextField
} from "@mui/material";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import React, { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import UsersListAutocomplete from "../admin/UsersListAutocomplete";
import ATSnackbar from "../layout/ATSnackbar";
import { DEFAULT_LOCALE, INR_CURRENCY_STYLE } from "../util/constant";
import UserStrategyRow from "./UserStrategyRow";

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  color: theme.palette.text.primary,
}));

const useStyles = makeStyles(theme => ({
  menuItem: {
    display: 'block',
  },
  profit: {
    color: 'green'
  },
  loss: {
    color: 'red'
  },
}))

export function getStrategies(user, setStrategies) {
  fetch('/algo-trading/api/strategies', {
    method: 'GET',
    headers: {
      "Content-Type": "application/json",
      'Authorization': user.credential,
    }
  }).then(function (response) {
    response.text().then(r => {
      if (response.ok) {
        const d = JSON.parse(r)
        if (d?.length > 0) {
          setStrategies([...d])
        }
      } else {
        console.log(r)
      }
    })
  })
}
const PortfolioConfig = ({ user, reloadUserStrategies }) => {
  const history = useHistory();
  const [strategies, setStrategies] = useState([]);
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');
  const [selectedUser, setSelectedUser] = useState("")
  const [holdingAmount, setHoldingAmount] = useState(0.0)
  const [availableCash, setAvailableCash] = useState(0.0)
  const [cashCapital, setCashCapital] = useState(0.0)
  const classes = useStyles();
  const shrinkProp = { shrink: true };
  const handleChange = (selectedUserObj) => {
    setSelectedUser(selectedUserObj?.email);
  };

  useEffect(() => {
    if (user === undefined || Object.keys(user).length === 0) {
      history.push('/')
    }
  }, [user, history])

  let defaultStrategyRow = {
    id: "",
    userId: "",
    tradeStrategy: "UPTREND",
    broker: "ANGEL_ONE",
    userBrokerAccountEntityId: '',
    investedAmount: 0.0,
    maxAmountPerTrade: 0.0,
    stopLossInPercentage: 0.0
  };

  const { register, handleSubmit, control,
    setValue, watch, setError, clearErrors, formState: { errors } } = useForm({
      defaultValues: {
        "strategies": [defaultStrategyRow]
      }
    })
  const { fields, remove, append, replace } = useFieldArray({
    control,
    name: "strategies"
  })

  useEffect(() => {
    getStrategies(user, setStrategies);
  }, [user, selectedUser])

  useEffect(() => {
    getAllUserStrategies();
  }, [selectedUser, reloadUserStrategies])


  function getAllUserStrategies() {
    fetch('/algo-trading/api/portfolio/strategies?user=' + selectedUser, {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        'Authorization': user.credential,
      }
    }).then(function (response) {
      response.text().then(r => {
        if (response.ok) {
          const d = JSON.parse(r)
          if (d?.length > 0) {
            setAvailableCash(d?.[0].availableCash)
            setHoldingAmount(d?.[0].portfolioHolding)
            if (d?.[0].cashCapital && d?.[0].cashCapital > 0) {
              setCashCapital(d?.[0].cashCapital)
            }
            else {
              setCashCapital(0.0)
            }
            replace(d)
          }
          else {
            replace(defaultStrategyRow)
          }
        } else {
          console.log(r)
        }
      })
    })
  }

  const removeRow = (index, userStrategyId) => {
    if (userStrategyId === undefined || userStrategyId === "") {
      remove(index)
      return
    }

    fetch('/algo-trading/api/portfolio/strategies/' + userStrategyId + '?user=' + selectedUser, {
      method: 'DELETE',
      headers: {
        "Content-Type": "application/json",
        'Authorization': user.credential,
      }
    }).then(function (response) {
      response.text().then(r => {
        if (response.ok) {
          setShowNotification(true)
          setNotificationMessage("Row removed")
          getAllUserStrategies()
        } else {
          console.log(r)
        }
      })
    })
  }

  const onChangeCashCapital = (event) => {
    setCashCapital(event.target.value)
    event.target.value <= (holdingAmount + availableCash) ? delete errors['cashCapital'] :
      errors['cashCapital'] = { "message": "should be <= Total portfolio amount" }
  }

  const onSubmit = data => {
    const payload = {
      "cashCapital": cashCapital,
      "strategies": data?.strategies
    }
    console.log('Submitted data', JSON.stringify(payload))

    fetch('/algo-trading/api/portfolio/strategies?user=' + selectedUser, {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
        'Authorization': user.credential,
      }
    }).then(function (response) {
      response.text().then(r => {
        setShowNotification(true)
        setNotificationMessage("Data submitted")
        getAllUserStrategies();
      })
    }, function (error) {
      console.log(error.message)
    })
  }

  const getAmount = () => {
    if (cashCapital === undefined || cashCapital === null || cashCapital === 0) {
      return holdingAmount + availableCash
    }
    return cashCapital
  }

  return (
    <Grid item xs={12}  >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid item xs={12}>
          <Typography variant="h4" gutterBottom component="div">
            Manage Strategies
          </Typography>
        </Grid>
        {showNotification && <ATSnackbar message={notificationMessage} open={showNotification} setOpen={setShowNotification} severity={'warning'} />}
        <Grid container xs={12} padding={1} spacing={1} component={Paper}>
          <UsersListAutocomplete loggedInUser={user} selectedUser={selectedUser} setSelectedUser={handleChange} />
          <Grid item xs={6} md={2}>
            {strategies && strategies.length > 0 && <TextField label='Portfolio holding @ 9:00 am'
              InputLabelProps={shrinkProp}
              InputProps={{ disabled: true }}
              aria-readonly={true}
              size="small"
              value={holdingAmount?.toLocaleString(DEFAULT_LOCALE, INR_CURRENCY_STYLE)} />}
          </Grid>
          <Grid item xs={1} md={1}>
            <Box sx={{ minWidth: 60, maxWidth: 100 }}>
              <Typography variant="h6" gutterBottom component="div">+</Typography>
            </Box>
          </Grid>
          <Grid item xs={5} md={2}>
            {strategies && strategies.length > 0 && <TextField label='Portfolio available cash @ 9:00 am'
              InputLabelProps={shrinkProp}
              InputProps={{ disabled: true }}
              aria-readonly={true}
              size="small"
              value={availableCash?.toLocaleString(DEFAULT_LOCALE, INR_CURRENCY_STYLE)} />}
          </Grid>
          <Grid item xs={1} md={1}>
            <Typography variant="h6" gutterBottom component="div">=</Typography>
          </Grid>
          <Grid item xs={6} md={2}>
            {strategies && strategies.length > 0 && <TextField label='Total portfolio amount'
              InputLabelProps={shrinkProp}
              InputProps={{ disabled: true }}
              size="small"
              value={(holdingAmount + availableCash)?.toLocaleString(DEFAULT_LOCALE, INR_CURRENCY_STYLE)} />}
          </Grid>
          <Grid item xs={5} md={2}>
            {strategies && strategies.length > 0 && <TextField label='Cash capital'
              InputLabelProps={shrinkProp}
              size="small"
              value={cashCapital}
              onChange={event => onChangeCashCapital(event)}
              error={errors && !!errors['cashCapital']}
              helperText={errors && errors['cashCapital']?.message}
              InputProps={{
                startAdornment: <InputAdornment position="start">₹</InputAdornment>,
              }}
            />
            }
          </Grid>
        </Grid>
        <Grid item xs={12}>
          &nbsp;
        </Grid>
        {fields.map((row, index) => (
          <Grid item xs={12} key={row?.id}>
            <Item key={row?.id}>
              <UserStrategyRow
                register={register}
                nameKey={`strategies.${index}`}
                index={index}
                control={control}
                setValue={setValue}
                watch={watch}
                onAddRow={() => append(defaultStrategyRow)}
                onDeleteRow={() => removeRow(index, row?.rowId)}
                errors={errors}
                strategyValues={strategies}
                portfolioAmount={getAmount()}
                setError={setError}
                clearErrors={clearErrors}
              />
            </Item>
            <Divider sx={{ display: { xs: 'block', sm: 'none' } }} />
          </Grid>
        ))}
        <Grid item xs={12}>
          &nbsp;
        </Grid>
        <Grid item xs={12}>
          <Button variant="contained" type="submit">Save</Button>
        </Grid>
      </form>
    </Grid>
  )
}

export default PortfolioConfig